import { create } from "zustand";
import type { ViewState } from "../../../lib/canvas-coordinates";

// キャンバス UI のローカル状態を管理する Zustand store。
// pan/zoom、選択中ツール、選択中オブジェクトなど高頻度更新の値を保持する。
// 永続化対象ではない（リロードすれば初期値に戻る）。

export type CanvasTool =
  | "idle"
  | "panning"
  | "place-sticky"
  | "place-shape"
  | "place-text"
  | "draw-pen";

export type ShapeKind = "circle" | "rectangle" | "arrow";

export interface PointerPosition {
  readonly x: number;
  readonly y: number;
}

interface CanvasUiState {
  view: ViewState;
  tool: CanvasTool;
  shapeKind: ShapeKind;
  selectedObjectIds: readonly string[];
  lastPointerStagePosition: PointerPosition | null;

  setView: (view: ViewState) => void;
  setTool: (tool: CanvasTool) => void;
  setShapeKind: (shape: ShapeKind) => void;
  setSelectedObjectIds: (ids: readonly string[]) => void;
  setLastPointerStagePosition: (point: PointerPosition | null) => void;
  resetMode: () => void;
}

export const useCanvasStore = create<CanvasUiState>((set) => ({
  view: { panX: 0, panY: 0, zoom: 1 },
  tool: "idle",
  shapeKind: "rectangle",
  selectedObjectIds: [],
  lastPointerStagePosition: null,

  setView: (view) => set({ view }),
  setTool: (tool) => set({ tool }),
  setShapeKind: (shapeKind) => set({ shapeKind }),
  setSelectedObjectIds: (selectedObjectIds) => set({ selectedObjectIds }),
  setLastPointerStagePosition: (lastPointerStagePosition) => set({ lastPointerStagePosition }),
  resetMode: () => set({ tool: "idle", selectedObjectIds: [] }),
}));
